module.exports = __webpack_public_path__ + "img/Pytheas.7f809b31.png";